export default __webpack_public_path__ + "static/media/arrow-link-up-collapse-small_white.4a7b0e19.svg";